// extracted by mini-css-extract-plugin
export default {"list":"style_list__CJVJg","list_item":"style_list_item__dgHZ8","img":"style_img__U9MHB","title":"style_title__ItZFB","text":"style_text__6hXH0","heading":"style_heading__TkM2B"};